<template>
  <ExtracadabraModal v-model:opened="internalOpen">
    <template #body>
      <div class="success-component">
        <QIcon name="fad fa-wallet" color="primary" size="100px" />
        <section>
          <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@CONGRATS_TITLE")) }}</h3>
          <p>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@CONGRATS_TEXT")) }}</p>
        </section>
        <section v-if="!hasEpctFeatureFlag">
          <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@FOLLOW_UP_TITLE")) }}</h3>
          <p>{{ $t("ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@FOLLOW_UP_TEXT") }}</p>
        </section>
      </div>
    </template>
    <template #footer>
      <div class="full-width row justify-center">
        <QBtn
          v-if="!hasEpctFeatureFlag"
          v-close-popup
          class="btn-navigation-half"
          color="primary"
          flat
          no-caps
          :label="$t('ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@ACTION_CLOSE')"
          @click="$emit('onClickAlreadyDone')"
        />
        <QBtn
          v-close-popup
          class="btn-navigation-half"
          color="secondary"
          no-caps
          :label="$t('ETAB.PAGES.EXTRA.SUBSCRIPTION_MODAL.@ACTION_OK')"
          @click="$emit('onClickIbanBtn')"
        />
      </div>
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      hasEpctFeatureFlag: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened", "onClickIbanBtn", "onClickAlreadyDone"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
  };
</script>
